import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebookF, FaInstagram, FaYoutube, FaApple, FaGooglePlay } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Left Section - Social Media */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="footer-section social-section"
          >
            <h3>Do you like our work?</h3>
            <p>If so, why not follow us on</p>
            <div className="social-icons">
              <motion.a
                href="https://www.facebook.com/creedomapp"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="social-icon facebook"
              >
                <FaFacebookF />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/creedom.app/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="social-icon instagram"
              >
                <FaInstagram />
              </motion.a>
              <motion.a
                href="https://www.youtube.com/@creedomapp"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="social-icon youtube"
              >
                <FaYoutube />
              </motion.a>
            </div>
          </motion.div>

          {/* Middle Section - App Downloads */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="footer-section app-section"
          >
            <h3>Download the Creedom App from the Play Store or the App Store</h3>
            <div className="app-buttons">
              <motion.a
                href="https://play.google.com/store/apps/details?id=com.billionfaces.casttree&hl=en-IN?utm_source=application_success"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className=""
              >
                <div className="app-icon">
                  <img 
                    src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757838684329plastore.png?generation=1757838676890185&alt=media" 
                    alt="Google Play Store" 
                    className="store-logo"
                  />
                </div>
                {/* <div className="app-text">
                  <span className="app-label">GET IT ON</span>
                  <span className="app-name">Google Play</span>
                </div> */}
              </motion.a>
              
              <motion.a
                href="https://apps.apple.com/in/app/creedom-prev-casttree/id6584517800?utm_source=application_success"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className=""
              >
                <div className="app-icon">
                  <img 
                    src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757838256962download.png?generation=1757838254211567&alt=media" 
                    alt="App Store" 
                    className="store-logo"
                  />
                </div>
                {/* <div className="app-text">
                  <span className="app-label">Download on the</span>
                  <span className="app-name">App Store</span>
                </div> */}
              </motion.a>
            </div>
          </motion.div>

          {/* Right Section - QR Code */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="footer-section qr-section"
          >
            <div className="qr-code">
              <img 
                src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757839107018sucess_qr.png?generation=1757839100099517&alt=media" 
                alt="Creedom App QR Code" 
                className="qr-image"
              />
            </div>
          </motion.div>
        </div>

        {/* Bottom Section - Copyright and Policies */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
          className="footer-bottom"
        >
          <div className="copyright">
            <span>Copyright © 2020-2025 Billion faces technologies private limited. All rights reserved.</span>
          </div>
          <div className="footer-links">
            <a href="https://creedom.app/refundPolicy" target="_blank" rel="noopener noreferrer" className="footer-link">Refund Policy</a>
            <span className="separator">.</span>
            <a href="https://creedom.app/privacyPolicy" target="_blank" rel="noopener noreferrer" className="footer-link">Privacy Policy</a>
            <span className="separator">.</span>
            <a href="https://creedom.app/termsConditions" target="_blank" rel="noopener noreferrer" className="footer-link">Terms of Use</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
